'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');
const LoadUrlMatcherTypes=require('../../../../dist-es6/client/services/paramSyncService').LoadUrlMatcherTypes;let

OrganizationProfileConfig=class OrganizationProfileConfig{
static get $inject(){return['$stateProvider','$urlMatcherFactoryProvider']}

constructor($stateProvider,$urlMatcherFactoryProvider){
LoadUrlMatcherTypes($urlMatcherFactoryProvider);
let feature=AngularHelpers.generateAuthenticatedFeatureConfig('organizationProfile');
$stateProvider.state(feature.fullName,feature.config);
}};


module.exports=OrganizationProfileConfig;
//# sourceMappingURL=organizationProfileConfig.js.map
